import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@xyflow/react/dist/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["Overview"] */ "/vercel/path0/src/app/(root)/dashboard/overview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Diagram"] */ "/vercel/path0/src/app/(root)/diagram/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/app/(root)/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceHeathCard"] */ "/vercel/path0/src/app/(root)/servicesHealth/card.tsx");
